
import React from "react";
import { Svg } from "chartist";
import { updateViewBox } from "../utils/UpdateViebox";
import { localizeValue } from "../utils/Labels";
import ChartistGraph from "../ChartistGraph/ChartistGraph";
import Tooltip from "@bge/chartist_custom_plugins/dist/es/tooltip/chartist-plugin-tooltip-custom";

const DotsChart = (props) => {
  const { labels = [], series = [], chartClassName = "ct-double-octave", options = {}, locale } = props;
  const data = { labels, series };

  const chartOptions = {
    axisY: {
      // labelInterpolationFnc: function(value) {
      //   return value + ' ;-)'
      // },
      showLabel: true,
      offset: 60,
      position: 'start',
      //stretch: false
    },
    axisX: {
      onlyInteger: true,
      //low: 0,
      //high: 100,
      //scaleMinSpace: 30
    },
    chartPadding: {
      top: 0,
      right: 20,
      bottom: 0,
      left: 50
    },
    low: 0,
    showArea: true,
    seriesBarDistance: 0,
    horizontalBars: true,
    fullWidth: true,
    ...options
  };

  const plugins = [
    Tooltip({
      appendToBody: true, 
      appendToPoint: true,
      tooltipFnc: (meta, value) => `${meta} <br> <p class="value-text">${prefix}${value}${suffix}</p>`,
      transformTooltipTextFnc: (value) => options.transform?.labels ? options.transform.labels(value, locale) :  localizeValue(value, locale)
    })
  ]

  const {prefix = "", suffix = ""} = options;

  const listener = {
    created: function (data) {
      updateViewBox(data);
    },
    draw: function (data) {
      if (data.type === 'bar') {
        data.group.append(new Svg('circle', {
          fill: '#41D592',
          cx: data.x2,
          cy: data.y2,
          'ct:value':  `${prefix}${data.value.x.toLocaleString(locale)}${suffix}`,
          r: 5
        }, 'ct-bar ct-dot-circle'));
      }
    }
  }

  return (
    <ChartistGraph 
      data={data} 
      options={{...chartOptions, plugins}} 
      type="Bar" 
      className={"dots-chart " + chartClassName}
      listener={listener}
    />
  );
};

export default DotsChart;